/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable default-case */
/* eslint-disable no-unreachable */
import React from 'react';
import SharedBalanceUpload from '@src/pages/ticketShared/balanceUpload/BalanceUpload';
import { VouIdCode } from '@src/store/enums';

const Wrapper = (props) => (
  <SharedBalanceUpload vouId={VouIdCode.Market} routes={["ticketMarketHeader"]} {...props} />
);

export default Wrapper;
